import API from '@/views/Fdc/Apis/'
import _ from 'lodash'

/**
 * Detection > Fault Action Plan
 * Fault Action Plan 관리
 */
export default {
  name: 'FaultActionPlan',
  watch: {
    /**
     * pageCurrent 변화 감지
     */
    pageCurrent () {
      this.searchUserList()
    }
  },
  beforeMount () {
    this.initColumns()
    this.getCodeList('faultLevel')
  },
  methods: {
    /**
     * Code 조회
     * @param {String} type code type
     */
    async getCodeList (type) {
      const payload = {
        codeType: type
      }
      const data = await API.Common.getCodesString(payload)
      // var data = await API.FdcDetection.codeList(type)
      this.faultLevelCodeList = [...data]
    },
    /**
     * Fault Action Plan 조회
     * @param {String} fab Fab
     * @param {String} eqpId EQP ID
     * @param {String} moduleId Module ID
     */
    async listFn (fab, eqpId, moduleId) {
      let payload = {
        fab: fab,
        eqpId: eqpId,
        moduleId: moduleId
      }
      let data = await API.FdcFaultActionPlan.faultActionPlanList(payload)
      this.rowData = [...data]
      this.faultActionModelGrid.select(-1, -1)
      this.selectedRowItem = null
    },
    async getFaultActionPlanList (fab, eqpId, moduleId) {
      let payload = {
        fab: fab,
        eqpId: eqpId,
        moduleId: moduleId
      }
      let data = await API.FdcFaultActionPlan.faultActionPlanList(payload)
      this.rowData = [...data]
      this.gridSelectionChanged([data[0]])
      // this.selectFirstData()
    },
    /**
     * Fault Action Plan Grid 초기화
     * @param {*} grid wijmo grid
     */
    initFaultActionModelGrid (grid) {
      this.faultActionModelGrid = grid
    },
    /**
     * Email Sending User List Grid 초기화
     * @param {*} grid wijmo grid
     */
    initUserListGrid (grid) {
      this.userListGrid = grid
    },
    /**
     * 컬럼 설정
     */
    initColumns () {
      this.columns = [ // Fault Action Plan grid column 배열
        { headerName: this.$t('fdc.COMMON.COLUMN.MODEL_NAME'), field: 'modelName', width: 150 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODEL_TYPE'), field: 'modelType', width: 120 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.STEP'), field: 'stepId', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.FAULT_LEVEL'), field: 'faultLevel', width: 120 },
        { headerName: this.$t('fdc.COMMON.COLUMN.EMAIL'), field: 'emailYn', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.INTER_LOCK'), field: 'interLockYn', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 150, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 110 }
      ]

      this.columnUserList = [ // Email Sending User List grid column 배열
        { headerName: this.$t('fdc.COMMON.COLUMN.PART'), field: 'part', width: 120, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.USER_ID'), field: 'userId', width: 120 },
        { headerName: this.$t('fdc.COMMON.COLUMN.USER_NAME'), field: 'userName', width: 120 },
        { headerName: this.$t('fdc.COMMON.COLUMN.EMAIL'), field: 'eMail', width: 180 }
      ]

      this.columnModalUserList = [ // User List b-table column 배열
        { headerName: this.$t('fdc.FAULT_ACTION.COLUMN.DEPT_NAME'), field: 'deptNm', width: 110, sortable: true, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.USER_ID'), field: 'userId', width: 110, sortable: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.USER_NAME'), field: 'userNm', width: 110, sortable: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EMAIL'), field: 'userEmail', sortable: true }
      ]
    },
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    /**
     * Fault Action Plan 검색
     */
    searchProcess () {
      if (this.selectedTreeNode.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Equipment']))
        return
      }
      let node = this.selectedTreeNode
      if (node.detail.moduleId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Module ID']))
        return
      }
      this.searchTreeNode = this.selectedTreeNode

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      this.getFaultActionPlanList(
        node.detail.fab,
        node.detail.eqpId,
        node.detail.moduleId
      )
      this.rowDataUsers = []
    },
    /**
     * Fault Action Plan grid row select event
     */
    gridSelectionChanged (rows) {
      if (rows.length === 1) {
        let data = { ...rows[0] }
        this.selectedRowItem = rows[0]
        if (data.faultLevel !== null && data.faultLevel !== undefined) {
          this.faultLevelSelect = data.faultLevel
          this.rowDataUsers = [...JSON.parse(data.userList)]

          if (data.interLockYn === 'Y') this.interLockCheckBox = true
          else this.interLockCheckBox = false

          if (data.emailYn === 'Y') this.emailCheckBox = true
          else this.emailCheckBox = false

          this.faultActionModify = true
        } else {
          this.faultLevelSelect = null
          this.rowDataUsers = []
          this.interLockCheckBox = false
          this.emailCheckBox = false
          this.faultActionModify = false
        }
        this.faultActionDisable = false
      } else {
        this.faultLevelSelect = null
        this.rowDataUsers = []
        this.interLockCheckBox = false
        this.emailCheckBox = false
        this.faultActionModify = false
        this.faultActionDisable = true
      }
    },
    /**
     * Fault Action Plan 재조회
     */
    refreshGrid () {
      if (this.searchTreeNode && this.searchTreeNode.length !== 0) {
        let selectEqpVo = this.searchTreeNode.detail
        this.getFaultActionPlanList(selectEqpVo.fab, selectEqpVo.eqpId, selectEqpVo.moduleId)
      }
      this.refreshFaultAction()
    },
    /**
     * Data 초기화
     */
    refreshFaultAction () {
      this.faultLevelSelect = null
      this.rowDataUsers = []
      this.interLockCheckBox = false
      this.emailCheckBox = false
      this.faultActionModify = false
      this.faultActionDisable = true
    },
    /**
     * Email Sending User List 재조회
     */
    refreshGridUsers () {
      if (this.faultActionModify) {
        this.rowDataUsers = [...JSON.parse(this.selectedRowItem.userList)]
      } else {
        this.rowDataUsers = []
      }
    },
    /**
     * Email Sending User List Grid에 check된 row count 확인
     * @returns {Boolean} check된 row가 있는지 여부
     */
    hasCheckedRowsUserList () {
      // if (!this.$refs.userListGrid) {
      //   return 0
      // }
      // return this.$refs.userListGrid.checkedRowCount > 0
      if (!this.userListSelectedRowItems) return true
      if (!this.userListSelectedRowItems.length < 1) return true
      return false
    },
    /**
     * 선택된 Fault Action Plan이 있는지 체크
     * @returns {Boolean} 선택된 row가 있는지 여부
     */
    existDataFaultAction () {
      if (this.selectedRowItem !== null) {
        return true
      } else {
        return false
      }
    },
    /**
     * Fault Action Plan 저장
     */
    async saveFaultActionModel () {
      let self = this
      let selectedItems = this.selectedRowItem
      let data = selectedItems
      let allUserList = [...this.rowDataUsers]
      data.interLockYn = this.interLockCheckBox ? 'Y' : 'N'
      data.emailYn = this.emailCheckBox ? 'Y' : 'N'
      data.faultLevel = this.faultLevelSelect
      data.userList = JSON.stringify(allUserList)

      if (!this.saveValidation(data)) {
        return
      }

      let message = this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')
      this.$dialog.confirm({
        message: message,
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          function saveLastProcess (response) {
            if (response != null && response.status === 200) {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'))
              // let node = self.searchTreeNode
              // self.listFn(node.detail.fab, node.detail.eqpId, node.detail.moduleId)
            } else {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_SAVE'))
            }
          }

          API.FdcFaultActionPlan.saveFaultActionPlan(data).then(result => {
            saveLastProcess(result)
          })
        },
        onCancel: function () {}
      })
    },
    /**
     * User grid row selection event
     * @param {Array} rows save data 배열
     */
    userListGridSelectionChanged (rows) {
      const checkedRows = this.$refs.userListGrid.gridApi.getSelectedRows()
      this.userListSelectedRowItems = checkedRows
    },
    /**
     * Save Validation
     * @param {Array} rows save data 배열
     * @returns {Boolean} validation 성공 여부
     */
    saveValidation (data) {
      if (!data.faultLevel || data.faultLevel.trim() === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Fault Level']))
        return false
      } else if (!data.interLockYn || data.interLockYn.trim() === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['MES Interlock']))
        return false
      } else if (!data.emailYn || data.emailYn.trim() === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Email Send']))
        return false
      } else if (!data.userList || data.userList.trim() === '' || data.userList === []) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['User List']))
        return false
      }
      return true
    },
    /**
     * Email Sending User List 삭제
     */
    _deleteUserList () {
      let self = this
      let message = this.$t('fdc.COMMON.MESSAGE.CONFIRM_DELETE')

      this.$dialog.confirm({
        message: message,
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          let allUserList = self.$refs.userListGrid.grid.rows
          let userList = []
          if (allUserList.length > 0) {
            for (var i = 0; i < allUserList.length; i++) {
              if (allUserList[i].dataItem._status) {
                if (!allUserList[i].dataItem._status.checked) {
                  var user = _.clone(allUserList[i].dataItem)
                  delete user['_status']
                  userList.push(user)
                }
              }
            }
          }
          self.rowDataUsers = userList
        },
        onCancel: function () {}
      })
    },
    deleteUserList () {
      // Get checked rows
      // splice array
      // setRowData or assign statment
      let self = this
      let message = this.$t('fdc.COMMON.MESSAGE.CONFIRM_DELETE')

      if (!this.userListSelectedRowItems && this.userListSelectedRowItems.length < 1) return

      this.$dialog.confirm({
        message: message,
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          let allUserList = self.rowDataUsers
          if (allUserList.length > 0) {
            const userList = _.differenceBy(allUserList, self.userListSelectedRowItems, 'userId') // 선택되지 않은 user list item만 추출
            self.rowDataUsers = userList
          } else {
            // self.rowDataUsers = []
          }
        },
        onCancel: function () {}
      })
    },
    /**
     * User List 조회
     */
    async searchUserList () {
      let payload = {}
      payload[this.searchCondition] = this.searchCondParam
      // payload['perPage'] = this.perPage
      // payload['nowPage'] = this.pageCurrent

      payload['perPage'] = this.paging.perPage
      payload['nowPage'] = this.paging.pageCurrent
      // this.modalUserListData = results.userListWithPageDtos
      // this.totalItems = results.totalCount
      // let results = await API.FdcFaultActionPlan.commUserManageSearchByParam(payload)
      this.modalUserListData = this.sampleModelUserListData
    },
    /**
     * 선택한 User List 적용
     */
    applyUser () {
      // let checkedRows = this.checkedRows
      let checkedRows = this.$refs.modalUserListGrid.gridApi.getSelectedRows()
      if (checkedRows.length < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Item']))
        return
      }

      let arr = []
      for (let i in checkedRows) {
        const rowItem = {
          part: checkedRows[i].deptNm,
          userId: checkedRows[i].userId,
          userName: checkedRows[i].userNm,
          eMail: checkedRows[i].userEmail
        }
        arr.push(rowItem)
        // this.$refs.userListGrid.addRows(arr)
      }
      let currentUserData = [...this.rowDataUsers].concat(arr)
      this.rowDataUsers = currentUserData
      this.userListModal.visible = false
      this.modalUserListData = []
      // this.checkedRows = []
    },
    /**
     * User List Modal 닫기
     */
    modalClose () {
      this.modalUserListData = []
      this.searchCondition = null
      this.searchCondParam = null
      this.userListModal.visible = false
    },
    /**
     * Data 초기화 (Fault Action Plan 1건에 대한)
     */
    clearFaultAction () {
      this.faultLevelSelect = null
      this.rowDataUsers = []
      this.interLockCheckBox = false
      this.emailCheckBox = false
    }
  },
  data () {
    return {
      columns: [],
      columnUserList: [],
      columnModalUserList: [],
      faultActionPlanGrid: null,
      userListGrid: null,
      userListSelectedRowItems: [], // 선택된 User list data
      modalUserListGrid: null,
      modalUserListGridSelectedRowItems: [], // 선택된 Modal user list data
      // columns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.MODEL_NAME'), binding: 'modelName', width: 150, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODEL_TYPE'), binding: 'modelType', width: 120, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.RECIPE'), binding: 'recipeId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.STEP'), binding: 'stepId', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.FAULT_LEVEL'), binding: 'faultLevel', width: 120, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.EMAIL'), binding: 'emailYn', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.INTER_LOCK'), binding: 'interLockYn', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), binding: 'modifyDt', width: 150, readOnly: true, dataType: 'Date', format: 'yyyy-MM-dd HH:mm:ss' },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), binding: 'modifyUser', width: 110, readOnly: true }
      // ], // Fault Action Plan grid column 배열
      // columnUserList: [
      //   { label: this.$t('fdc.COMMON.COLUMN.PART'), binding: 'part', width: 120, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.USER_ID'), binding: 'userId', width: 120, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.USER_NAME'), binding: 'userName', width: 120, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.EMAIL'), binding: 'eMail', width: 180, readOnly: true }
      // ], // Email Sending User List grid column 배열
      // columnModalUserList: [
      //   { label: this.$t('fdc.FAULT_ACTION.COLUMN.DEPT_NAME'), field: 'deptNm', sortable: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.USER_ID'), field: 'userId', sortable: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.USER_NAME'), field: 'userNm', sortable: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.EMAIL'), field: 'userEmail', sortable: true }
      // ], // User List b-table column 배열
      selectedTreeNode: [], // 선택된 EQP Tree node
      searchTreeNode: [], // 검색된 EQP Tree node
      rowData: [], // Fault Action Plan grid row data
      originRowData: [], // Fault Action Plan grid row data
      selectedRowItem: null, // 선택된 Fault Action Plan data
      rowDataUsers: [], // Email Sending User List grid row data
      originRowDataUsers: [], // Email Sending User List grid row data
      faultActionModify: false, // 선택된 Fault Action Plan의 Save가 Modify인지 여부
      interLockCheckBox: false, // MES Interlock checkbox data
      emailCheckBox: false, // Email Send checkbox data
      faultLevelSelect: null, // Fault Level data
      faultLevelCodeList: [], // Fault Level combobox 배열
      faultActionDisable: true, // MEW Interlock, Email Send, Fault Level 활성화 여부
      modalUserListData: [], // User List Modal user dat 배열
      userListModal: {
        visible: false
      }, // User List Modal 표시 여부
      searchCondParam: null, // User List 조회 조건 (text)
      searchCondition: null, // User List 조회 조건 (combobox)
      checkedRows: [], // User List Modal에서 선택한 User 목록
      perPage: 10, // User List Modal에 User List page당 건수
      pageCurrent: 1, // User List Modal에 User List 현재 page
      totalItems: 0, // User List Modal에 User List 전체 건수
      paging: {
        type: ['none', 'load-more', 'pagination'][2],
        size: 20, // page per size 설정
        currentPage: 0, // 0으로 초기설정
        totalPage: 1, // 1로 초기설정
        totalElements: 1
      },
      sampleModelUserListData: [
        { deptNm: 'testDept', userId: 'test01', userNm: '홍길동', userEmail: 'hong@conwin.com' },
        { deptNm: 'testDept', userId: 'test02', userNm: '김영희', userEmail: 'kyh@conwin.com' },
        { deptNm: 'testDept', userId: 'test03', userNm: '김철수', userEmail: 'kcs@conwin.com' },
        { deptNm: 'testDept', userId: 'test04', userNm: '이순신', userEmail: 'lss@conwin.com' },
        { deptNm: 'testDept', userId: 'test05', userNm: '김좌진', userEmail: 'kjj@conwin.com' }
      ], // Sample User List (추후 삭제)
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true
      }
    }
  }
}
